import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DetailWrapper from '../../CardRow/DetailWrapper';
import { getMonthName } from '../../../utils/date';
import { useIntl } from 'react-intl';
import capitalize from '@material-ui/core/utils/capitalize';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import { useForm } from 'react-hook-form';
import { useGetEndDates } from '../../../pages/TradingConfigPage/hooks/api/configurationApi';

const daysSkelet = () => {
  const skelet = [];
  for (let i = 1; i <= 12; i++) {
    skelet.push({ month: i, purchaseDay: dateString(i) });
  }
  return skelet;
};

const dateString = (month) => {
  const actualDate = new Date();
  let year = actualDate.getFullYear();
  const day = '01';
  let result = '2020-01-01';
  if (month === 1) {
    month = 12;
    year = year - 1;
  } else {
    month = month - 1;
  }
  if (month <= 9) {
    month = `0${month}`;
  }
  result = `${year}-${month}-${day}`;
  return result;
};

const PurchaseLastDays = ({ contract, handlers, editable, setEditable, isNew, idPanel, handler, setOpen, isPurchaseLastDaysTabActive }) => {
  const { purchaseLastDays, postLoadingContract, putLoadingContract, contractPeriod } = contract;

  const { setPurchaseLastDays, sendHandler } = handlers;
  const { getEndDates, data: defaultPurchaseLastDays } = useGetEndDates();
  const { handleSubmit, register, errors } = useForm();
  const intl = useIntl();
  const saveTitle = 'app.buttons.save';
  const cancelTitle = 'app.buttons.cancel';
  const continueTitle = 'app.buttons.continue';

  const handleChange = (idButton) => {
    if (!isNew) {
      setEditable(!editable);
      if (idButton !== 'cancel') {
        setOpen(true);
        sendHandler();
      }
    } else {
      handler(idPanel, true);
    }
  };

  const mapToPurchaseLastDays = (endDates) => {
    return endDates.map((endDate) => {
      return {
        id: endDate.id,
        month: endDate.month,
        purchaseDay: endDate.date,
      };
    });
  };

  useEffect(() => {
    if (isPurchaseLastDaysTabActive && contractPeriod) {
      getEndDates(contractPeriod);
    }
  }, [isPurchaseLastDaysTabActive, contractPeriod, getEndDates]);

  useEffect(() => {
    if (isNew && defaultPurchaseLastDays && Object.keys(defaultPurchaseLastDays).length !== 0) {
      setPurchaseLastDays(mapToPurchaseLastDays(defaultPurchaseLastDays[Object.keys(defaultPurchaseLastDays)[0]]));
    } else if (!purchaseLastDays) {
      setPurchaseLastDays(daysSkelet());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPurchaseLastDays, setPurchaseLastDays, isNew]);

  const handlePurchaseLastDaysChange = (purchaseDay, newPurchaseDay) => {
    const purchaseLastDaysIndex = purchaseLastDays.findIndex((purchaseLastDay) => {
      return purchaseLastDay.month === purchaseDay.month;
    });

    setPurchaseLastDays((oldState) => {
      const newState = [...oldState];
      newState[purchaseLastDaysIndex].purchaseDay = newPurchaseDay;
      return newState;
    });
  };

  return (
    <>
      <DetailWrapper>
        <SectionWrapper>
          <form onSubmit={handleSubmit(handleChange)}>
            {purchaseLastDays &&
              purchaseLastDays.map((item) => (
                <CustomTextField
                  key={item.month}
                  name={item.month.toString()}
                  onChange={(event) => {
                    event.stopPropagation();
                    handlePurchaseLastDaysChange(item, event.target.value);
                  }}
                  label={capitalize(getMonthName(intl, new Date(2000, item.month - 1, 1)))}
                  value={item.purchaseDay}
                  variant="outlined"
                  type="date"
                  disabled={!editable}
                  inputRef={register({
                    required: true,
                  })}
                  helperText={errors[item.month]?.message}
                  error={!!errors[item.month]}
                />
              ))}
            <ButtonWrapper>
              <DefaultButton
                id={'cancel'}
                primary={false}
                disabled={!editable}
                title={cancelTitle}
                onClick={(event) => {
                  handleChange(event.currentTarget.id);
                }}
              />
              <DefaultButton
                primary={true}
                disabled={!editable}
                type="submit"
                title={isNew ? continueTitle : saveTitle}
                loaders={[postLoadingContract, putLoadingContract]}
              />
            </ButtonWrapper>
          </form>
        </SectionWrapper>
      </DetailWrapper>
    </>
  );
};

PurchaseLastDays.propTypes = {
  contract: PropTypes.object,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  setEditable: PropTypes.func,
  handler: PropTypes.func,
  idPanel: PropTypes.any,
  setOpen: PropTypes.func,
  isPurchaseLastDaysTabActive: PropTypes.bool,
};

export default PurchaseLastDays;
